import {
    getApplicationProduct,
    listApplicationProducts
} from './queries';

import {
    generateClient,
    GraphQLQuery,
} from 'aws-amplify/api';

import {
    GetApplicationProduct,
    ListApplicationProducts
} from "../types.ts";
import {showErrorNotifications} from "../../../components/ServiceNotifications.tsx";
import {platformApiConfig} from "../config";
import {fetchAuthSession} from "aws-amplify/auth";


export const fetchRecords = async (filter?: { [key: string]: string }) => {

    const {credentials} = await fetchAuthSession();

    const client = generateClient({
                                      endpoint: platformApiConfig.endpoint,
                                      region: platformApiConfig.region,
                                      authMode: 'iam',
                                      credentials: {
                                          accessKeyId: credentials?.accessKeyId,
                                          secretAccessKey: credentials?.secretAccessKey,
                                          sessionToken: credentials?.sessionToken
                                      }
                                  });

    if (!filter) {
        filter = {};
    }
    filter.applicationId = platformApiConfig.applicationId;

    try {
        const response = await client.graphql<GraphQLQuery<ListApplicationProducts>>({
                                                                                         query: listApplicationProducts,
                                                                                         variables: {
                                                                                             filter: filter
                                                                                         },
                                                                                     });
        return response.data?.listApplicationProducts;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const fetch = async (id: string) => {


    const {credentials} = await fetchAuthSession();

    const client = generateClient({
                                      endpoint: platformApiConfig.endpoint,
                                      region: platformApiConfig.region,
                                      authMode: 'iam',
                                      credentials: {
                                          accessKeyId: credentials?.accessKeyId,
                                          secretAccessKey: credentials?.secretAccessKey,
                                          sessionToken: credentials?.sessionToken
                                      }
                                  });


    try {
        const response = await client.graphql<GraphQLQuery<GetApplicationProduct>>({
                                                                                       query: getApplicationProduct,
                                                                                       variables: {id: id},
                                                                                   });
        return response.data?.getApplicationProduct;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};